import React from "react";
import "./toast.scss";

const Toast = ({ toastMessage, showToast }) => {
  return (
    <div className="flex-the-toast">
      <div style={{ display: showToast }} className="custom-toast">
        {toastMessage}{" "}
      </div>
    </div>
  );
};

export default Toast;
